<template>
    <div class="qiye" @click="onclick">
        <div class="qiye-f qiye-item" v-if="!value">
            <div class="qiye-item-t">企业</div>
            <span class="qiye-item-b">
                <span>享受</span>
                <span class="red">立减 5 折</span>
                <span>优惠价</span>
            </span>

        </div>
        <div class="qiye-t qiye-item" v-else>
            <div class="qiye-item-t">企业</div>
            <span class="qiye-item-b">
                <span>享受</span>
                <span class="red">立减 5 折</span>
                <span>优惠价</span>
            </span>
           
        </div>
    </div>
</template>

<script>
export default {
    components: {},
    props: {

        value: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {

        };
    },
    created() { },
    computed: {},
    methods: {
        onclick(){
            this.$emit('input',!this.value)
        }
    },
};
</script>

<style scoped lang='scss'>
.qiye {
    .red {
       color: #FFE194
    }

    &-f {}

   

    &-item {
        width: 280px;
        height: 44px;
        flex-shrink: 0;
        border-radius: 4px;
        border: 1px solid #3F3F66;
        background: #3F3F66;
        line-height: 44px;
        text-align: center;
        position: relative;
        cursor: pointer;

        &-t {
            width: 32px;
            height: 18px;
            line-height: 18px;
            text-align: center;
            color: #FFF;
            font-size: 10px;
            border-radius: 4px 0px 4px 0px;
            position: absolute;
            top: -1px;
            left: -1px;
            background: #FFE194;
            color: #303149;
        }

        &-b {
           color: #FFFFFF
        }
    }
    &-t {
       
        border: 1px solid  #FFE194;
    }
}
</style>